module.exports = __webpack_public_path__ + "static/media/13ITC3.54c4cd82.jpg";